import { render, staticRenderFns } from "./stock_tab.vue?vue&type=template&id=4c067faa&scoped=true&"
import script from "./stock_tab.vue?vue&type=script&lang=js&"
export * from "./stock_tab.vue?vue&type=script&lang=js&"
import style0 from "./stock_tab.vue?vue&type=style&index=0&id=4c067faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c067faa",
  null
  
)

export default component.exports